export const LOCAL_SIGN_OUT_SUPPRESSION_KEY = 'finance:auth:local-sign-out-suppressed';

export function isLocalSignOutSuppressed(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(LOCAL_SIGN_OUT_SUPPRESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function setLocalSignOutSuppressed(suppressed: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    if (suppressed) window.localStorage.setItem(LOCAL_SIGN_OUT_SUPPRESSION_KEY, '1');
    else window.localStorage.removeItem(LOCAL_SIGN_OUT_SUPPRESSION_KEY);
  } catch {
    // Storage is best-effort; the active tab still clears its local auth state.
  }
}
